<template>
  <main>
    <section class="content-wrapper">
      <ag-header
        title="Rechnungen"
      />
      <ag-date-select
        :year-only="true"
        :available-years="availableYears"
        @yearSelected="setYear($event)"
        class="invoices__select"
      />
      <div class="invoices">
        <div class="invoices__loader" v-if="loading"></div>
        <div class="invoices__err-msg" v-if="!contentList">
          <div>
            {{ statusMsg }}
          </div>
          <ag-button
            v-if="errorState"
            class="invoices__button"
            @click="loadListData"
          >
            Erneut senden
          </ag-button>
        </div>
        <div class="invoices" v-if="contentList">
          <ul class="invoices__list">
            <li
              class="invoices__list-item"
              v-for="invoice in contentList"
              :key="`statistic-${invoice.billingNumber}`"
            >
              <invoice :invoice="invoice" />
            </li>
          </ul>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import AgHeader from '@/components/shared/AgHeader.vue';
import AgDateSelect from '@/components/shared/AgDateSelect.vue';
import AgButton from '@/components/shared/AgButton.vue';
import Invoice from '@/components/dashboard/Invoice.vue';
import { mapState } from 'vuex';

export default {
  name: 'marketing',
  components: {
    AgHeader,
    AgDateSelect,
    AgButton,
    Invoice,
  },
  metaInfo: {
    title: 'Redaktionsmarketing',
  },
  props: {
    serviceData: {
      type: Array,
      default: null,
      required: false,
    },
    activeServices: {
      type: Array,
      default: null,
      required: false,
    },
    inactiveServices: {
      type: Array,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      unwatchCustomerId: null,
      availableYears: [],
      selectedYear: new Date().getFullYear(),
      loading: true,
      errorState: false,
      contentList: [],
      apiUrl: process.env.VUE_APP_API_ENDPOINT,
    };
  },
  computed: {
    ...mapState({
      customerId: (state) => state.user.customerId,
    }),
  },
  mounted() {
    if (this.customerId) {
      this.loadAvailableYears();
      this.loadListData();
    } else {
      this.unwatchCustomerId = this.$watch('customerId', (newVal, oldVal) => {
        if (newVal !== oldVal) {
          this.loadAvailableYears();
          this.loadListData();
        }
        this.unwatchCustomerId();
      });
    }
  },
  destroy() {
    if (this.unwatchCustomerId) {
      this.unwatchCustomerId();
    }
  },
  methods: {
    setYear(year) {
      this.selectedYear = year;
      this.loadListData();
    },
    loadAvailableYears() {
      this.availableYears = null;
      this.axios(`${this.apiUrl}/customer/${this.customerId}/billing/years/`)
        .then(({ data }) => {
          this.availableYears = data;
        })
        .catch(() => {
          this.availableYears = null;
        });
    },
    loadListData() {
      this.contentList = null;
      this.loading = true;
      this.errorState = false;
      this.statusMsg = 'Die gewünschten Daten werden geladen';
      this.axios(`${this.apiUrl}/customer/${this.customerId}/billing/${this.selectedYear}/`)
        .then(({ data }) => {
          this.loading = false;
          this.contentList = data;
        })
        .catch(() => {
          this.loading = false;
          this.errorState = true;
          this.contentList = null;
          this.statusMsg = 'Ups, da ist etwas schief gelaufen.';
        });
    },
  },
};
</script>

<style lang="scss">

.invoices {
  margin-top: rem(25px);

  &__select {
    position: absolute;
    right: rem(10px);
    top: rem(20px);

    @include mq($mq-large) {
      right: rem(30px);
      top: rem(30px);
    }
  }

  &__list {
    padding: 0;
    list-style: none;
  }

  &__err-msg {
    text-align: center;
    font-family: $copy-font;
    font-size: rem(18px);
    font-weight: 600;
    margin: rem(20px) 0;
  }

  &__loader {
    border: 10px solid #f3f3f3;
    border-top-color: $secondary-color;
    border-radius: 50%;
    width: rem(80px);
    height: rem(80px);
    margin: rem(20px) auto;
    animation: spin 2s linear infinite;

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  }
}

</style>
